import { useFormContext } from "react-hook-form";

import FormInput from "@/components/form-fields/form-input";
import { FileUploaderComponent } from "@/components/reusables/FileUpload";
import FormWrapper from "@/components/reusables/custom-form-fields/FormWrapper";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import {
  allowAllFileExceptImage,
  allowedImageTypes,
} from "@/constants/constants";
import { ProductType } from "@/interfaces/tools.interface";
import { cn, formatToCapitalizedWords } from "@/lib/utils";
import { TAddProduct } from "@/schemas/tools.schema";

const ProductForm = ({
  disableField,
}: {
  disableField?: boolean;
}): JSX.Element => {
  const form = useFormContext<TAddProduct>();

  return (
    <section className='space-y-8'>
      <div className=' grid grid-cols-2 gap-3 space-y-1 items-end'>
        <FormInput
          form={form}
          name='name'
          label='Name'
          required
          input={{
            placeholder: "Enter Product Name",
          }}
        />
        <FormInput
          form={form}
          name='images'
          render={(field, _, formState) => {
            return (
              <FileUploaderComponent
                field={field}
                formState={formState}
                acceptFileTypes={allowedImageTypes}
                isMultiple={true}
                labelsProps={{
                  label: "Upload Image",
                  showLabel: true,
                }}
                {...field}
              />
            );
          }}
        />
        <FormInput
          form={form}
          name='files'
          render={(field, _, formState) => {
            return (
              <FileUploaderComponent
                field={field}
                formState={formState}
                acceptFileTypes={allowAllFileExceptImage}
                allowVideoUpload={true}
                isForFileUpload={true}
                isMultiple={true}
                excludeFileLimit={true}
                labelsProps={{
                  label: "Upload Files",
                  showLabel: true,
                }}
                {...field}
              />
            );
          }}
        />
      </div>
      <FormInput
        form={form}
        label='Type of Product'
        name='type'
        render={(field) => {
          return (
            <RadioGroup
              onValueChange={field.onChange}
              defaultValue={field.value}
              value={field.value}
              className='flex flex-wrap gap-4 ml-2'
              disabled={disableField}
            >
              {Object.values(ProductType).map((type) => (
                <FormWrapper
                  key={type}
                  label={formatToCapitalizedWords(type)}
                  className={cn("flex space-y-0 items-center gap-[11px]")}
                  labelWrapperClassName='order-2 w-full'
                >
                  <RadioGroupItem value={type} />
                </FormWrapper>
              ))}
            </RadioGroup>
          );
        }}
      />
      <FormInput
        form={form}
        name='quantity'
        label='Quantity'
        required
        input={{
          placeholder: "Enter Quantity",
          type: "number",
          disabled: disableField,
          className: "w-1/2",
        }}
      />
    </section>
  );
};

export default ProductForm;
